<template>
  <BLayoutList
    :title="pageTitle"
    :create-route="createRoute"
    :skeleton="isLoadingAsyncData"
  >
    <template #filter>
      <ComponentFilter
        :data="filters"
        :skeleton="isLoadingAsyncData"
        @change="onChangeFilter"
      />
    </template>

    <BTableCommon
      v-model="selected"
      type="permission-groups"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @action:delete="onDeleteWithRefresh"
      @action:copy="onCopy"
    />
  </BLayoutList>
</template>

<script>
import { authGroupPermissions } from '@/helpers/enums/permission-models'
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { PermissionsGroupModel as Model } from './Model'
import {
  permissionsGroupsStoreModule as StoreModule,
  permissionsGroupsStoreMapper as StoreMapper,
} from './store'
import {
  GROUPS_ROUTES as ROUTES,
} from './utils'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import ComponentFilter from './components/PermissionsGroupsFilter.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ViewPermissionsGroupsList',
  components: {
    BLayoutList,
    BTableCommon,
    ComponentFilter,
  },
  mixins: [
    listMixin,
  ],
  computed: {
    createRoute() {
      const editable = this.$access(authGroupPermissions.edit)
      return editable ? { name: ROUTES.CREATE } : void 0
    },
  },
  methods: {
    ...StoreMapper.mapActions(['copy']),

    async onCopy(params, callback) {
      const unwatch = callback?.()

      try {
        const { data } = await this.copy(params)
        const location = {
          name: ROUTES.EDIT,
          params: { id: data.id },
        }
        this.$router.push(location)
      } catch (e) {
        this.$notice.errors(e)
      }

      unwatch?.()
    },
  },
}
</script>
